module.exports = __webpack_public_path__ + "static/media/testimonialImage.6fa5f41c.png";